"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AccordionPanel_meta_1 = require("../AccordionPanel.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('div', AccordionPanel_meta_1.ACCORDION_PANEL_CATEGORY_KEY, AccordionPanel_meta_1.ACCORDION_PANEL_COMPONENT_KEY, ['header']);